import React, { useEffect } from "react";

import ToggleSwitch from "../../../../../CommonComponents/ToggleSwitch/ToggleSwitch";

import { BRAND_ICONS_URLS, PERSONAL_LIMITS } from "../../../../../../utils/Constants";
import moneyFormatter from "../../../../../../utils/MoneyFormatter";
import RebetLoader from "../../../../../CommonComponents/RebetLoader/RebetLoader";
import { AppStrings } from "../../../../../../utils/constants/AppStrings";

function SportsbookLimits({
  userPersonalLimit,
  setTitle,
  setIsViewPersonalLimitsPopupVisible,
  setIsEditWaggerLimitsPopupVisible,
  setIsEditLossLimitsPopupVisible,
  getUserPersonalLimit,
  isApiRunning,
  setEditingMode,
}) {
  const handleEditClick = (section) => {
    setEditingMode(true);
    switch (section) {
      case PERSONAL_LIMITS.WAGGER_LIMITS:
        setTitle(AppStrings.EDIT_WAGGER_LIMITS);
        setIsViewPersonalLimitsPopupVisible(false);
        setIsEditWaggerLimitsPopupVisible(true);
        break;
      case PERSONAL_LIMITS.LOSS_LIMITS:
        setTitle(AppStrings.EDIT_LOSS_LIMITS);
        setIsViewPersonalLimitsPopupVisible(false);
        setIsEditLossLimitsPopupVisible(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    getUserPersonalLimit(false);
  }, []);

  return (
    <div className="personal-limits-body">
      {isApiRunning ? (
        <RebetLoader />
      ) : (
        <>
          <div className="personal-limits-section-container">
            <div className="personal-limits-section-header">
              {AppStrings.WAGGER_LIMITS}
              <span
                className="personal-limits-edit-button"
                onClick={() => handleEditClick(PERSONAL_LIMITS.WAGGER_LIMITS)}
              >
                {AppStrings.EDIT}
              </span>
            </div>
            <div className="personal-limits-section-body">
              <div className="personal-limits-section-item border-bottom">
                <div>
                  <div className="personal-limits-section-item-label">
                    {AppStrings.MAX_PURCHASE_AMOUNT_OF_SECONDARY_CURRENCY_CAN_BE_WAGERED_PER_DAY}
                    day
                  </div>
                  <div className="personal-limits-section-item-value">
                    <img
                      src={process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL + BRAND_ICONS_URLS.secondaryCurrencySymbol}
                      alt="Coin Icon"
                      width={15}
                      height={15}
                    />
                    <span>
                      {userPersonalLimit.max_coin_wagered_per_day !== false
                        ? moneyFormatter(
                          userPersonalLimit.max_coin_wagered_per_day
                        )
                        : "-"}
                    </span>
                  </div>
                </div>
                <ToggleSwitch
                  status={userPersonalLimit.max_coin_wagered_per_day}
                  eventCode={"123"}
                  updateEventCode={() => { }}
                />
              </div>
              <div className="personal-limits-section-item">
                <div>
                  <div className="personal-limits-section-item-label">
                    {AppStrings.MAX_AMOUNT_OF_PRIMARY_CURRENCY_CAN_BE_WAGERED_PER_DAY}
                  </div>
                  <div className="personal-limits-section-item-value">
                    <img
                      src={process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL + BRAND_ICONS_URLS.primaryCurrencySymbol}
                      alt="Cash Icon"
                      width={15}
                      height={15}
                    />
                    <span>
                      {userPersonalLimit.max_cash_wagered_per_day !== false
                        ? moneyFormatter(
                          userPersonalLimit.max_cash_wagered_per_day
                        )
                        : "-"}
                    </span>
                  </div>
                </div>
                <ToggleSwitch
                  status={userPersonalLimit.max_cash_wagered_per_day}
                  eventCode={"123"}
                  updateEventCode={() => { }}
                />
              </div>
            </div>
          </div>
          <div className="personal-limits-section-container">
            <div className="personal-limits-section-header">
              {AppStrings.LOSS_LIMITS}
              <span
                className="personal-limits-edit-button"
                onClick={() => handleEditClick(PERSONAL_LIMITS.LOSS_LIMITS)}
              >
                {AppStrings.EDIT}
              </span>
            </div>
            <div className="personal-limits-section-body">
              <div className="personal-limits-section-item border-bottom">
                <div>
                  <div className="personal-limits-section-item-label">
                    {AppStrings.MAX_AMOUNT_OF_SECONDARY_CURRENCY_YOU_WILL_ALLOW_YOURSELF_TO_LOSE_EACH_DAY}
                  </div>
                  <div className="personal-limits-section-item-value">
                    <img
                      src={process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL + BRAND_ICONS_URLS.secondaryCurrencySymbol}
                      alt="Coin Icon"
                      width={15}
                      height={15}
                    />
                    <span>
                      {userPersonalLimit.max_coin_loss_per_day !== false
                        ? moneyFormatter(
                          userPersonalLimit.max_coin_loss_per_day
                        )
                        : "-"}
                    </span>
                  </div>
                </div>
                <ToggleSwitch
                  status={userPersonalLimit.max_coin_loss_per_day}
                  eventCode={"123"}
                  updateEventCode={() => { }}
                />
              </div>
              <div className="personal-limits-section-item">
                <div>
                  <div className="personal-limits-section-item-label">
                    {AppStrings.MAX_AMOUNT_OF_PRIMARY_CURRENCY_YOU_WILL_ALLOW_YOURSELF_TO_LOSE_EACH_DAY}
                  </div>
                  <div className="personal-limits-section-item-value">
                    <img
                      src={process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL + BRAND_ICONS_URLS.primaryCurrencySymbol}
                      alt="Cash Icon"
                      width={15}
                      height={15}
                    />
                    <span>
                      {userPersonalLimit.max_cash_loss_per_day !== false
                        ? moneyFormatter(
                          userPersonalLimit.max_cash_loss_per_day
                        )
                        : "-"}
                    </span>
                  </div>
                </div>
                <ToggleSwitch
                  status={userPersonalLimit.max_cash_loss_per_day}
                  eventCode={"123"}
                  updateEventCode={() => { }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SportsbookLimits;
